import React from 'react';
import './Home.css'

const Aboutsub = () => {
    return (
        <div data-aos="fade-up" data-aos-delay='500' data-aos-duration='800' className='md:rounded-2xl rounded-none mx-auto  relative md:z-50 p-4 md:p-6 lg:w-8/12 srt-bg lg:my-20 shadow-2xl'>
            <div className="hero-overlay bg-opacity-60"></div>
            <div className="text-center">
                <h1 className='md:text-5xl text-3xl mb-5 text-primary'>Wanna Know About Us?</h1>
                <div className=''>
                    <p className="mb-5 text-xl lg:mx-20 text-white">Lens Tree is the global leader in providing Camera Lenses, technology and services. Founded in 2022, Lens Tree exists to encourage connect people through innovative live camera technology. The company is headquartered in Northern New Jersey and maintains 12 additional offices worldwide.</p>
                </div>
                <button className="btn btn-primary">About Us</button>
            </div>
        </div>
    );
};

export default Aboutsub;